import React, { FC } from 'react';
import styles from './PlayerInfoItem.module.scss';

interface PlayerInfoItemProps {
	label: string;
	value: string;
}

const PlayerInfoItem: FC<PlayerInfoItemProps> = ({ label, value }): JSX.Element => (
	<div className={styles.InfoItem}>
		<p className={styles.Label}>{label}</p>
		<p className={styles.Value}>{value}</p>
	</div>
);
export { PlayerInfoItem };
